/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Advisor } from './content/trainer'
import TrainerModal from '../lib/modal'

export default function Advisors() {
  return (
    <main id="main" data-aos="aos-init aos-animate">
      <div className="breadcrumbs">
        <div className="container">
          <h2>Advisors</h2>
          <p>We at ARA , apart from teaching, will guide every individuals to become productive.</p>
        </div>
      </div>
      <section id="trainers" className="trainers">
        <div className="container aos-init aos-animate" data-aos="fade-up">

          <div className="row aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
          {Advisor.map((trainer, index) => {
        return (
        <div key={index} className="col-lg-4 col-md-6 d-flex align-items-stretch">
          <div className="member">
            <img src={trainer.image} width="300" loading="lazy" height="300" alt="" />
            <div className="member-content">
              <h4>{trainer.name}</h4>
              <TrainerModal id={index} data={Advisor}/>
            </div>
          </div>
        </div>)})}
          </div>

        </div>
      </section>
    </main>
  )
}
